// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Zcn7","consentsList":"PatientConsents_consentsList__2vamy","consentsListEmpty":"PatientConsents_consentsListEmpty__2EaqB"};